export default __webpack_public_path__ + "static/media/statisticOne.4b71c558.svg";